module.exports = __webpack_public_path__ + "img/mceasy-loader.771c06bd.gif";